if (!customElements.get('tr-theme-scroll')) {
  customElements.define('tr-theme-scroll', class extends HTMLElement {
    connectedCallback() {
      const rail = this.querySelector('.tr-theme-rail');
      const controls = this.querySelector('.tr-rail-controls');
      if (!rail || !controls) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const buttons = controls.querySelectorAll('button');
      const update = () => {
        controls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
        buttons[0].disabled = rail.scrollLeft <= 2;
        buttons[1].disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      const move = (direction) => rail.scrollBy({
        left: direction * rail.clientWidth * 0.8,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      buttons.forEach((button) => button.addEventListener('click', () => move(Number(button.dataset.direction)), { signal }));
      rail.addEventListener('keydown', (event) => {
        if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      rail.addEventListener('scroll', update, { passive: true, signal });
      window.addEventListener('resize', update, { signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(rail);
      }
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
